import { LeafNode, TreeNode } from "@/types/General";

export const generatePaths = (
  node: TreeNode,
  path: string = "",
): (LeafNode & { path: string })[] => {
  if (node.type === "leaf") {
    return [
      {
        ...node,
        path: path + node.name,
      },
    ];
  }
  return node.children.flatMap((childNode) =>
    generatePaths(childNode, node.name + "\\"),
  );
};

export const getLastCategory = (value: string) => {
  const splitFullCategory = value?.split("\\");
  const category = splitFullCategory?.[splitFullCategory?.length - 1];

  return category;
};

export const createTree = (categories: string[]): TreeNode[] => {
  return categories.reduce((acc: TreeNode[], category: string): TreeNode[] => {
    const [categoryName, ...rest] = category.split("\\");
    if (rest.length === 0) {
      return [
        ...acc,
        {
          type: "leaf",
          name: categoryName,
        },
      ];
    }

    if (
      acc.some(
        ({ name, type }) => name === categoryName && type === "intermediate",
      )
    ) {
      return acc;
    }

    const children = createTree(
      categories
        .filter((category) => category.startsWith(categoryName + "\\"))
        .map((category) => category.substring((categoryName + "\\").length)),
    );

    return [
      ...acc,
      {
        type: "intermediate",
        name: categoryName,
        children,
      },
    ];
  }, [] as TreeNode[]);
};
